/**
 * OrderStatusBadge — badge colorido por status_id (11 estados).
 */

export const STATUS_COLORS = {
  1: 'gray',     // DRAFT
  2: 'red',      // BLOCKED
  3: 'blue',     // DELIVERED
  4: 'green',    // DONE
  5: 'dark-gray',// CANCELED
  6: 'cyan',     // AVAILABLE
  7: 'orange',   // PENDING
  8: 'yellow',   // WAITING_HOSPITALAR_RESOLUTION
  9: 'teal',     // RELEASED_BY_HOSPITALAR
  10: 'purple',  // WAITING_EXCEPTION_APPROVAL
  11: 'pink',    // NEEDS_CLIENT_REVIEW
};

export const STATUS_LABELS = {
  1: 'Rascunho',
  2: 'Bloqueada',
  3: 'Enviada SAP',
  4: 'Finalizada',
  5: 'Cancelada',
  6: 'Disponível',
  7: 'Pendente',
  8: 'Aguarda Hospitalar',
  9: 'Liberada Hospitalar',
  10: 'Aguarda Exceção',
  11: 'Revisão Cliente',
};

const OrderStatusBadge = ({ statusId, size = 'md' }) => (
  <span className={`gencrm_badge gencrm_badge--${STATUS_COLORS[statusId] || 'gray'} gencrm_badge--${size}`}>
    {STATUS_LABELS[statusId] || `#${statusId}`}
  </span>
);

export default OrderStatusBadge;
